export type OpsCopilotMode = 'external_agent_runtime' | 'embedded_copilot';

const STORAGE_KEY = 'edgentik:ops_copilot_mode:v1';

export function getOpsCopilotMode(): OpsCopilotMode {
  try {
    const raw = String(localStorage.getItem(STORAGE_KEY) || '').trim();
    if (raw === 'embedded_copilot' || raw === 'external_agent_runtime') return raw;
  } catch {
    // ignore
  }
  return 'external_agent_runtime';
}

export function setOpsCopilotMode(mode: OpsCopilotMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore
  }
}

